import React, { Suspense, lazy, useEffect } from 'react';
import { SpeedInsights } from '@vercel/speed-insights/react';
import SiteControls from "./components/site-controls/SiteControls";
import { SiteSettingsProvider } from "./context/SiteSettings";
import { PortfolioDataProvider } from "./context/PortfolioData";
import { Navigate, Route, Routes, useLocation, useParams } from "react-router-dom";

const HomePage = lazy(() => import("./pages/home/HomePage"));
const BlogPage = lazy(() => import("./pages/blog/BlogPage"));
const ArticlePage = lazy(() => import("./pages/blog/[id]/ArticlePage"));

const ArticleRoute = () => {
  const { slug } = useParams();
  return <ArticlePage slug={slug} />;
};

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
};

const AppContent = () => {
  return (
    <>
      {process.env.NODE_ENV === "production" && <SpeedInsights />}
      <SiteControls />
      <ScrollToTop />
      <Suspense fallback={<main className="container">Loading...</main>}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<ArticleRoute />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </>
  );
};

const App = () => (
  <SiteSettingsProvider>
    <PortfolioDataProvider>
      <AppContent />
    </PortfolioDataProvider>
  </SiteSettingsProvider>
);

export default App;
